import React from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import inputMask from "simple-keyboard-input-mask";
import {IMaskInput} from 'react-imask';
import langLayouts from './LangLayouts';
export default class Form extends React.Component {

    constructor(props) {
		super(props);
		this.inputs = {};
		this.inputs.phone = React.createRef();
		this.inputs.email = React.createRef();
		this.inputs.name = React.createRef();
		this.state = {
			name : '',
			email : '',
			phone : '',
			phone_complete : false,
			agree : true,
			currentInput : '',
			layoutName : 'default',
			lang : 'ru'
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.setCurrentInput = this.setCurrentInput.bind(this);
		this.handleChangeByKeyboard = this.handleChangeByKeyboard.bind(this);
		this.onKeyPress = this.onKeyPress.bind(this);
		this.onMaskInputAccept = this.onMaskInputAccept.bind(this);
		this.isKiosk = false;
		this.keyboard = React.createRef();
		let queryString = window.location.search;
		if (queryString=='?kiosk=1') this.isKiosk = true;
		this.langs = langLayouts;
		
    }
	
	onMaskInputAccept = (field, value) => {
		if (!field) return;
		let input = this.inputs[field].current;
		if (value.length===0)
			input.classList.add("error");
		else
			input.classList.remove("error");
		this.setState({
			[field]: value
		});
	}
	
	onKeyPress(button) {
		if (button === "{shift}" || button === "{lock}") this.handleShift();
		if (button === "{lang_en}") this.setState({lang: 'en'});
		if (button === "{lang_ru}") this.setState({lang: 'ru'});
	}
	
	handleShift() {
		let currentLayout = this.keyboard.current.options.layoutName;
		let shiftToggle = currentLayout === "default" ? "shift" : "default";
		this.keyboard.current.setOptions({
			layoutName: shiftToggle
		});
	}

	
	handleSubmit(e){
		e.preventDefault();
		let empty_error = false;
		const inputs = this.inputs;
		if (this.state.name.length==0){
			inputs.name.current.classList.add("error");
			empty_error = true;
		}		
		if (this.state.email.length==0){
			inputs.email.current.classList.add("error");
			empty_error = true;
		}
		if (
			(this.state.phone.length!=15 && this.isKiosk) || 
			(this.state.phone.length!=10 && !this.isKiosk)) 
		{
			inputs.phone.current.classList.add("error");
			empty_error = true;
		}
		if (empty_error) return;
		const regex = /\s|\(|\)|-/ig;
		let phone = this.state.phone.replaceAll(regex,'');
		this.props.setForm({
			name : this.state.name,
			email : this.state.email,
			phone : phone
		});
		let postData = {
			msisdn : phone
		}
		let postEnc = [];
		for (let f in postData) {
			let encodedKey = encodeURIComponent(f);
			let encodedValue = encodeURIComponent(postData[f]);
			postEnc.push(encodedKey + "=" + encodedValue);
		}
		let formBody = postEnc.join("&");
		fetch('/brandquiz/auth', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			},
			body: formBody
		})
		.then(response => {
			if (response.status != 200 && response.status != 400)
				throw new Error('Ошибка отправки запроса на сервер');
			return response;
		})
		.then(response => response.json())
		.then(data => {
			if ('error' in data) {
				alert(data.error);
				return;
			}
			this.props.changeStep('confirm');
		}).catch(err => {
			alert(err.message);
		});		
	}
	
	handleChange(e) {
		if (e.target.value.length==0)
			e.target.classList.add("error");
		else
			e.target.classList.remove("error");
		let inputVal = e.target.value;		
		
		const keyboardInput = this.keyboard.current ? this.keyboard.current.getInput() : undefined;

		/**
		 * Masked keyboard value takes precedence
		 * Except when deleting
		 */
		if (e.target.id == 'phone' && inputVal >= keyboardInput) {
			inputVal = keyboardInput;
		}
		//if input from normal keyboard sets the same on virtual keyboard
		this.setState({
			[e.target.id]: inputVal
		},()=> {
			//if (keyboardInput!==undefined)
			if (this.keyboard.current)
				this.keyboard.current.setInput(inputVal,e.target.id);
		});		
	}
	
	setCurrentInput(e) {
/*		this.setState({
			currentInput : e.target.id,
			keyboardOpen : true
		},() => {
			switch (e.target.id) {
				case 'phone':
					this.keyboard.setOptions({
						inputPattern : /^[\d]+$/,
						maxLength : 10
					});
					break;
				case 'name':
					this.keyboard.setOptions({
						inputPattern : /^[a-zЁёА-я\s]+$/,
						maxLength : 200
					});
					break;
				case 'email':
					this.keyboard.setOptions({
						inputPattern : /^[0-9a-z-_@\.]+$/,
						maxLength : 200
					});
					break;
				default:
					break;
			}
		});
*/

		this.setState({
			currentInput : e.target.id
		});
	}
	
	handleChangeByKeyboard(inputVal){
		let fields = Object.keys(inputVal);
		fields.forEach(field => {
			if (field==='') return;
			let input = this.inputs[field].current;
			if (input.length===0) 
				input.classList.add("error");
			else
				input.classList.remove("error");
		});
		this.setState(inputVal);
	}
	
	getLang() {
		return this.langs[this.state.lang];
	}
	
	render() {
		let {currentInput,layoutName} = this.state;
		let keysDisplay = {
			"{enter}": "Enter",
			"{escape}": "esc ⎋",
			"{tab}": "tab ⇥",
			"{bksp}": "⌫",
			"{lock}": "caps lock ⇪",
			"{shift}": "⇧",
			"{controlleft}": "ctrl ⌃",
			"{controlright}": "ctrl ⌃",
			"{altleft}": "alt ⌥",
			"{altright}": "alt ⌥",
			"{space}": "&nbsp;&nbsp;&nbsp;",
			"{lang_en}" : "Английский",
			"{lang_ru}" : "Русский"
		}
		return (
			<form class="subscribe-form" onSubmit={this.handleSubmit} autoComplete={'new-password'}>
				<div class="form-row">
					<label for="name">Ваше имя:</label>
					<input autoComplete="off"  id="name" type="text" ref={this.inputs.name} value={this.state.name} onChange={this.handleChange} onFocus={this.setCurrentInput}/>
				</div>
				<div class="form-row">
					<label for="email">Ваш e-mail:</label>
					<input autoComplete="off"  id="email"  ref={this.inputs.email} type="email" value={this.state.email}  onChange={this.handleChange} onFocus={this.setCurrentInput}/>
				</div>
				<div class="form-row">
					<label for="phone">Ваш телефон:</label>
					{this.isKiosk? <input 
						id="phone" 
						value={this.state.phone} 
						placeholder={"(000) 000-00-00"}
						className={'input'}
						onFocus={this.setCurrentInput}
						onChange={this.handleChange}
						ref={this.inputs.phone} 
						autoComplete={'off'}
					/>	:
					<IMaskInput 
						autoComplete={'off'} 
						value={this.state.phone} 
						mask= "+7 (000) 000-00-00" 
						id="phone"
						name="phone" 
						unmask={true} 
						placeholder='введите телефон' 
						required 
						inputRef={el => this.inputs.phone.current = el}
						onAccept={val => this.onMaskInputAccept('phone',val)}
					/>
					}
				</div>
				<div class="checkbox-row">
					<label for="agree">
						Я согласен с <a href={process.env.PUBLIC_URL + '/rules.pdf'} target="_blank">Условиями обработки и использования</a> моих персональных данных
						<input readOnly checked={this.state.agree} id="agree" type="checkbox" />
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="button-row">
					<button class="btn btn-arrow" type="submit">Отправить</button>
				</div>
				{this.isKiosk &&
					<div className={'keyboardContainer'}>
							<Keyboard
								keyboardRef={r => (this.keyboard.current = r)}
								inputName={currentInput}
								layoutName={layoutName}
								onChangeAll={this.handleChangeByKeyboard}
								display={keysDisplay}
								//debug={true}
								onModulesLoaded={() => {
									//console.log("Modules loaded!");
								}}
								inputMask={{
								  "phone": {
									mask: '(999) 999-99-99',
									regex: /^[0-9]+$/
								  }
								}}
								modules={[inputMask]}
								// Optional ( If you want to handle *physical* keyboard typing):
								inputMaskPhysicalKeyboardHandling={true}
								inputMaskTargetClass={"input"}
								layout={this.getLang()}
								onKeyPress={this.onKeyPress}
								mergeDisplay={true}
							/>
					</div>
				}
			</form>
		);
	}

}